import { windowInfo as wInfo } from './WindowInfo.js';
import { pcsp } from './Pcsp.js';
import {ClassRootEl } from './ClassBase.js';
import { CONFIG } from '../config.js';

export interface SmoothScrollOp {
	/**
	 * スクロール先のハッシュ
	 */
	hash?: string,

	/**
	 * CONFIG.scrollOffsetから追加のオフセット値
	 */
	offset?: {
		/**
		 * PC時の追加オフセット
		 * @defaultValue 0
		 */
		pc?: number,

		/**
		 * SP時の追加オフセット
		 * @defaultValue 0
		 */
		sp?: number,
	},
}

/**
 スムーススクロール

@example JS
```js
import { SmoothScroll } from '/assets/js/modules/SmoothScroll.js';
new SmoothScroll(null, {
	hash: '#test'
})
```
 */

export class SmoothScroll {
	#hash;
	#top = 0;
	$el: JQuery<any>;
	op: SmoothScrollOp = {
		offset: {
			pc: 0,
			sp: 0,
		},
	};

	constructor(el: ClassRootEl, event: Event, op?: SmoothScrollOp){
		/**
		 * ルート要素
		 */
		this.$el = $(el);
		this.event = event;
		this.op = {
			...this.op,
			...op,
		}
	}

	/**
	 * ルート要素のhrefの値 or オプションのhash値の要素までスクロール
	 */
	scrollByHash(){
		this.#hash = this.$el[0]?.hash || this.op?.hash;

		if(this.#urlCheck()) {
			this.event.preventDefault();
			this.to($(this.#hash))
		}
	}


	#urlCheck(){
		if(!this.#hash) { return true }
		const url = new URL(this.$el[0]?.href)
		const page = new URL(location.href);
		return page.host == url?.host && page.pathname == url?.pathname
	}

	#stopScroll(){
		$('html,body').stop();
	}

	/**
	 * 引数に指定した要素までスクロールする
	 */
	to($target: string | HTMLElement | JQuery<any>): void{
		this.#top = ($($target).eq(0).offset()?.top || 0) - wInfo.sc.offset[pcsp.mode] - this.op.offset![pcsp.mode];

		this.#stopScroll()
		$(window).one('wheel', (event) => {
			this.#stopScroll();
		});
		$('html,body').animate({
			scrollTop: this.#top,
		},CONFIG.scrollAnim.speed, CONFIG.scrollAnim.easing, ()=> {
			$(window).off('wheel');
		});
	}
}


/**
スムーススクロールさせるやつ<br/>importするだけで使える<br/>[data-no-scroll]が付いてるとスクロールしない
@name smoothScroll

@example HTML
```html
<p><a href="#scrollToSomewhere">これはスクロールする</a></p>
<p><a href="#scrollToSomewhere" data-no-scroll>これはスクロールしない</a></p>
```

@example JS
```js
import '/assets/js/modules/SmoothScroll.js';
```
*/
export const smoothScroll = $(document).on('click', '[href*="#"]', function(event) {
	if($(this).is('[data-no-scroll]')) return

	new SmoothScroll(this, event).scrollByHash()
});
